<template>
  <div>
    <v-autocomplete
      :label="label"
      :items="sortedCurrencyList"
      v-model="selectedCurrency"
      item-value="id"
      :item-text="itemTextCurrencies"
      return-object
      dense
      clearable
      outlined
      v-disabled-icon-focus
      :rules="required ? [(v) => (!!v && !!v.id) || 'Moeda obrigatória'] : []"
      :no-data-text="noDataText"
      :hide-details="hideDetails"
      :search-input.sync="search"
      :class="{ 'currency-select--searching': isSearching }"
    >
      <template #selection="{ item }">
        <span class="currency-option">
          <img
            v-if="getCurrencyFlag(item.code)"
            :src="getCurrencyFlag(item.code)"
            :alt="item.code"
            class="currency-option__flag"
          />
          <span class="currency-option__text">{{ itemTextCurrencies(item) }}</span>
        </span>
      </template>
      <template #item="{ item, attrs, on }">
        <v-list-item
          v-bind="attrs"
          v-on="on"
          :data-test="'item-moeda-' + (item.id || item.code || '')"
        >
          <v-list-item-content>
            <v-list-item-title>
              <span class="currency-option">
                <img
                  v-if="getCurrencyFlag(item.code)"
                  :src="getCurrencyFlag(item.code)"
                  :alt="item.code"
                  class="currency-option__flag"
                />
                <span class="currency-option__text">{{ itemTextCurrencies(item) }}</span>
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import mixinCurrencyFlag from '@/mixin/mixin-currency-flag';

export default {
  name: 'CurrencySelect',
  mixins: [mixinCurrencyFlag],
  props: {
    currencyList: {
      type: Array,
      required: true
    },
    value: {
      type: Object,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Moeda'
    }
  },
  data() {
    return {
      selectedCurrency: this.value,
      search: null
    };
  },
  computed: {
    itemTextCurrencies() {
      return (item) => item && item.code + ' - ' + item.name;
    },
    sortedCurrencyList() {
      if (!this.currencyList) return [];

      return [...this.currencyList].sort((a, b) => b.priority - a.priority);
    },
    /** Digitando algo diferente da moeda escolhida: a busca toma o lugar da selecao */
    isSearching() {
      return !!this.search && this.search !== this.itemTextCurrencies(this.selectedCurrency);
    },
    noDataText() {
      return !this.currencyList || !this.currencyList.length ? 'Nenhuma moeda disponível' : '';
    }
  },
  watch: {
    selectedCurrency(newValue) {
      this.$emit('input', newValue);
    },
    value(newValue) {
      this.selectedCurrency = newValue;
    }
  }
};
</script>

<style scoped>
/* A bandeira acompanha o texto; o TEXTO é quem encolhe com reticências.
   Sem o max-width, o span estoura a linha do select e o campo quebra em
   duas — a seleção nativa do Vuetify trunca, o slot custom precisa repor. */
.currency-option {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
}

/* A busca fica sobreposta a selecao, sem dividir a linha: a moeda escolhida
   mantem a largura toda, focada ou nao. Ao digitar, a selecao sai e o texto
   da busca aparece no lugar. */
.v-autocomplete ::v-deep .v-select__selections {
  position: relative;
}

.v-autocomplete ::v-deep .v-select__selections input {
  position: absolute;
  inset: 0;
  min-width: 0;
  width: 100%;
  background: transparent;
  color: transparent;
}

.v-autocomplete.currency-select--searching ::v-deep .v-select__selections input {
  color: inherit;
}

.v-autocomplete.currency-select--searching ::v-deep .v-select__selections .currency-option {
  visibility: hidden;
}

.currency-option__flag {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  border-radius: 50%;
  object-fit: cover;
}

.currency-option__text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
